import { useCallback, useEffect, useState } from 'react'
import { useLocation, useParams } from 'react-router'
import { ComponentWithPermissions } from '../../../../../../../baseComponents/CreateRoutering/types'
import EditCardTabs from '../../../../../../../baseComponents/EditCardTabs'
import { twinFetchPostJSON } from '../../../../../../../utils/globals/data'
import { getBasePath } from '../../../../../../../utils/globals/link'
import { ComponentTabObject } from '../../../../../../../utils/hooks/useTabLogic'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'
import { setVariablesToCurrentPage } from '../../../../../../../utils/reducers/reduxDispatch'
import { getProductName, parseSelectedCategories } from '../../Products/SingleProduct/function'
import MainAddon from './Tabs/MainAddon'
import OtherInformation from '../../../../../../../specificComponents/Product/ProductLayout/Tabs/OtherInformation'
import SpecificPricesProduct from '../../../../../../../specificComponents/Product/ProductLayout/Tabs/SpecificPricesProduct'
import StockProduct from '../../../../../../../specificComponents/Product/ProductLayout/Tabs/StockProduct'
import SuppliersProduct from '../../../../../../../specificComponents/Product/ProductLayout/Tabs/SuppliersProduct'
import { ProductExtendedTyShort } from '../../../../../../../specificComponents/Product/types'
import ParentsAddon from './Tabs/ParentsAddon'


type SingleAddonProps = SingleAddonLogicProps & ComponentWithPermissions & {}

const SingleAddon: React.FC<SingleAddonProps> = ({ userPermissions }) => {
    const location = useLocation()
    const params = useParams<{ id: string, tab?: string }>()
    const { t } = useTwinTranslation()
    const { basicData, getData } = useSingleAddonLogic({ params })
    if (!params.id) {
        return null
    }
    const tabs: ComponentTabObject = {
        'main': { component: MainAddon, text: t('general', 'General'), permission: 'product.addon.main' },
        'stock': { component: StockProduct, text: t('stock', 'Inventario'), permission: 'product.addon.stock' },
        'prices': { component: SpecificPricesProduct, text: t('prices', 'Precios'), permission: 'product.addon.specificPrice' },
        'suppliers': { component: SuppliersProduct, text: t('suppliers', 'Proveedores'), permission: 'product.addon.supplier' },
        'other-information': { component: OtherInformation, text: t('otherInformation', 'Otra información'), permission: 'product.addon.otherInformation' },
        'parents': { component: ParentsAddon, text: t('usedOn', 'Usado en'), permission: 'product.addon.main' },
    }
    return (<EditCardTabs basePath={getBasePath(location.pathname, params.id)} basicData={basicData} tabs={tabs} tab={params.tab} userPermissions={userPermissions} getData={getData} />)
}

interface SingleAddonLogicProps {
    params: { id?: string, tab?: string }
}

const useSingleAddonLogic = ({ params }: SingleAddonLogicProps) => {
    const [basicData, setBasicData] = useState<ProductExtendedTyShort | null>(null)
    const id = params.id

    const getData = useCallback(async () => {
        const myData: ProductExtendedTyShort = await twinFetchPostJSON('/api/app/product/getProductInstanceComplete', {
            id,
        })
        if (myData) {
            myData['parsedCategories'] = parseSelectedCategories(myData?.CategoriesProducts)
            myData['name'] = getProductName(myData.ProductLangs)
            setBasicData(myData)
            setVariablesToCurrentPage([myData['name']])
        }
    }, [setBasicData, id])

    useEffect(() => {
        getData()
    }, [getData])

    return { basicData, getData }
}

export default SingleAddon